import { Button, Form, Input, Space, Tabs, message } from 'antd'
import React, { useState, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'
import styles from './modify.scss'
const { TabPane } = Tabs
const ModifyInfo = (props) => {
  // 属性
  const [createModalVisible, handleModalVisible] = useState(false)
  const [tabKey, handleTabKey] = useState('User')
  const user = new User()
  const [formUser] = Form.useForm()
  const [formPwd] = Form.useForm()

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = () => {
    setUserInfo()
    handleModalVisible(true)
  }

  const setUserInfo = () => {
    formUser.setFieldsValue({ phone: user.getUserPhone(), nm: user.getUserName() })
  }

  // 处理信息修改
  const onFinish = async(values) => {
    const isUser = tabKey === 'User'
    const url = isUser ? 'updUser' : 'updPwd'
    user[url](isUser ? { nm: values.nm, typeCd: user.getUserTypeCd() } : values).then(()=>{
      message.success('修改成功')
      user.setUserName(values.nm)
      setTimeout(()=>{
        handleModalVisible(false)
      }, 300)
    }).catch((err)=>{
      console.log('error', err)
    })
  }
  const handleChangeKey = (key)=>{
    handleTabKey(key)
  }

  const passwordValid = ({ getFieldValue }) => ({
    validator(_, value) {
      console.log('orginP', getFieldValue('newPwd'))
      console.log('value', value)
      const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (!value) {
        return Promise.reject(new Error('请再次输入密码'))
      }
      if (cnReg.test(value)) {
        return Promise.reject(new Error('密码不能为中文'))
      }
      if (!value || getFieldValue('newPwd') === value) {
        return Promise.resolve()
      }
      return Promise.reject(new Error('两次输入密码不一致!'))
    }
  })

  const validatePwd = () => ({
    validator(_, value) {
      if (value) {
        const reg = new RegExp('^(?![A-Z]*$)(?![a-z]*$)(?![0-9]*$)(?![^a-zA-Z0-9]*$)\\S+$')
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (value && (value.length < 8 || value.length > 35)) {
          return Promise.reject(new Error('请输入8到35位的密码'))
        }
        if (!(reg.test(value)) || (cnReg.test(value))) {
          return Promise.reject(new Error('密码需大小写字母、数字、字符两种及以上组合'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('请输入密码')
      }
    }
  })

  const tailLayout = {
    wrapperCol: { offset: 8, span: 16 }
  }

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 }
  }

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='账号信息修改'
        visible={createModalVisible}
        onCancel={() => handleModalVisible(false)}
        footer={null}
        width={400}
      >
        <Tabs defaultActiveKey='User' onChange={handleChangeKey}>
          <TabPane tab='用户管理' key='User'>
            <Form
              form={formUser}
              {...layout}
              onFinish={onFinish}
              name='normal_login'
              className={styles['login-form']}
            >

              <Form.Item
                label='姓名'
                name='nm'
                rules={[{ required: true, message: '姓名不能为空' }]}
              >
                <Input
                  placeholder='姓名'
                />
              </Form.Item>
              <Form.Item
                name='phone'
                label='手机号'
              >
                <Input disabled placeholder='手机号/用户名' />
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Space>
                  <Button onClick={() => handleModalVisible(false)} >
                  取消
                  </Button>
                  <Button type='primary' htmlType='submit' >
                  确定
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </TabPane>
          <TabPane tab='密码修改' key='Pwd'>
            <Form
              form={formPwd}
              {...layout}
              onFinish={onFinish}
              name='normal_login'
              className={styles['login-form']}
            >

              <Form.Item
                label='原密码'
                name='oldPwd'
                rules={[
                  { required: true, message: '原密码不能为空' },
                  { min: 6, max: 35, message: '请输入6-35位字符登录密码' }
                ]}
                getValueFromEvent = {cnInputCheck}
              >
                <Input.Password
                  onCopy={(e) => e.preventDefault()}
                  placeholder='请输入原密码'
                />
              </Form.Item>
              <Form.Item
                label='新密码'
                name='newPwd'
                rules={[
                  validatePwd
                ]}
                getValueFromEvent = {cnInputCheck}
              >
                <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请输入8-35位字符登录密码' />
              </Form.Item>
              <Form.Item
                label='确认密码'
                name='cnewPwd'
                rules={[
                  passwordValid
                ]}
                getValueFromEvent = {cnInputCheck}
              >
                <Input.Password onCopy={(e) => e.preventDefault()} placeholder='请再次确认密码' />
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Space>
                  <Button onClick={() => handleModalVisible(false)} >
                  取消
                  </Button>
                  <Button type='primary' htmlType='submit' >
                  确定
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>

      </Modal>
    </Fragment>
  )
}

export default ModifyInfo
